import { render, staticRenderFns } from "./CompaniesLayout.vue?vue&type=template&id=0c71a4ae&scoped=true&"
import script from "./CompaniesLayout.vue?vue&type=script&lang=js&"
export * from "./CompaniesLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c71a4ae",
  null
  
)

export default component.exports